export enum ValidationResult {
  EMPTY_VALUE = 'EMPTY_VALUE',
  NON_ALPHANUMERIC = 'NON_ALPHANUMERIC',
  VALID = 'VALID',
}

export const PLATE_DEFAULT_REGEX = /[a-zA-Z]{3}[-\s]{0,1}[0-9]{4}/;
export const PLATE_MERCOSUL_REGEX = /[a-zA-Z]{3}[0-9]{1}[a-zA-Z]{1}[0-9]{2}/;
const SPACE_DASH_REGEX = /[-\s]{1}/;

export const validateLicensePlate = (inputValue: string): ValidationResult => {
  const normalized = inputValue.trim().toLowerCase();
  if (normalized.length === 0) return ValidationResult.EMPTY_VALUE;
  if (!normalized.match(/[0-9a-z]/)) return ValidationResult.NON_ALPHANUMERIC;
  return ValidationResult.VALID;
};

export const isPlateOutOfStandard = (plate: string): boolean => {
  if (!plate || validateLicensePlate(plate) !== ValidationResult.VALID) return false;
  return !(PLATE_DEFAULT_REGEX.test(plate) || PLATE_MERCOSUL_REGEX.test(plate));
};

export const getPlateFromInput = (input?: string): string => {
  const match = input && (input.match(PLATE_DEFAULT_REGEX) || input.match(PLATE_MERCOSUL_REGEX));
  return match?.[0] ?? '';
};

export const formatLastValidPlate = (plate: string): string => plate.replace(SPACE_DASH_REGEX, '').toUpperCase();
